define.alias("ember-cli-string-helpers/helpers/uppercase", "calendar/helpers/uppercase");